export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  isCheckable: true,
  isDetailed: false,
  customRowKey: 'uid',
  fields: [{
    name: 'field-generic-input',
    prop: 'name',
    width: '400px',
    title: 'Item Name',
    id: 'name',
  },
  {
    name: 'qty-not-scheduled',
    prop: 'quantity',
    width: '112px',
    title: 'Available',
    id: 'available',
  },
  {
    name: 'qty-to-ship',
    prop: 'selectedQty',
    width: '120px',
    title: 'Qty To Ship',
    id: 'selectedQty',
  }],
};
